import { fromFetch } from 'rxjs/fetch';
import { marketingcampaignUnsubscribe, marketingcampaignUnsubscribeFeedback } from 'constants/routes'

/**
 * updatePreferences: method to POST the update preferences of marketing campaigns
 * @param {object} payload payload with the information for the command.
 */
export const unsubscribeMarketingCampaign$ = (payload) => {
  const url = marketingcampaignUnsubscribe;

  return fromFetch(url, {
    method: 'POST',
    body: JSON.stringify({
      unsubscribeMarketingCampaignCommand: payload
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });
}

/**
 * submitUnsubscribeFeedback: method to POST the usubscribe feedback of marketing campaigns.
 * @param {object} payload payload with the information for the command.
 */
export const unsubscribeFeedback$ = (payload) => {
  const url = marketingcampaignUnsubscribeFeedback;

  return fromFetch(url, {
    method: 'POST',
    body: JSON.stringify({
      submitUnsubscribeFeedbackCommand: payload
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  });
}
